function createAudioMeter(audioContext, clipLevel, averaging, clipLag) {
  var processor = audioContext.createScriptProcessor(512);
  processor.onaudioprocess = volumeAudioProcess;
  processor.clipping = false;
  processor.lastClip = 0;
  processor.volume = 0;
  processor.clipLevel = clipLevel || 0.98;
  processor.averaging = averaging || 0.95;
  processor.clipLag = clipLag || 750;

  // this will have no effect, since we don't copy the input to the output,
  // but works around a current Chrome bug.
  processor.connect(audioContext.destination);
  processor.checkClipping = function () {
    if (!this.clipping) return false;
    if (this.lastClip + this.clipLag < window.performance.now())
      this.clipping = false;
    return this.clipping;
  };

  processor.shutdown = function () {
    this.disconnect();
    this.onaudioprocess = null;
  };

  return processor;
}

function volumeAudioProcess(event) {
  var buf = event.inputBuffer.getChannelData(0);
  var bufLength = buf.length;
  var sum = 0;
  var x;

  // Do a root-mean-square on the samples: sum up the squares...
  for (var i = 0; i < bufLength; i++) {
    x = buf[i];
    if (Math.abs(x) >= this.clipLevel) {
      this.clipping = true;
      this.lastClip = window.performance.now();
    }
    sum += x * x;
  }

  // ... then take the square root of the sum.
  var rms = Math.sqrt(sum / bufLength);

  // Now smooth this out with the averaging factor applied
  // to the previous sample - take the max here because we
  // want "fast attack, slow release."
  this.volume = Math.max(rms, this.volume * this.averaging);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
} ////////////////////
//// AUDIO CODE ////
////////////////////
let audioContext;
let microphone, meter;

// Get request for microphone usage
const requestAudioAccess = () => {
  if (navigator.mediaDevices) {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => setAudioStream(stream))
      .catch((err) =>
        alert("This pen requires a microphone to work properly.")
      );
  } else alert("Your browser does not support required microphone access.");
};

// Set up to record volume
const setAudioStream = (stream) => {
  audioContext = new AudioContext();
  microphone = audioContext.createMediaStreamSource(stream);
  meter = createAudioMeter(audioContext);

  const filter = audioContext.createBiquadFilter();
  filter.type = "lowpass";
  filter.frequency.value = 400;

  microphone.connect(filter);
  filter.connect(meter);
};

// Check if is blowing
let lowpass = 0;
const ALPHA = 0.5,
  THRESHOLD = 0.0008;

const isBlowing = () => {
  lowpass = ALPHA * meter.volume + (1.0 - ALPHA) * lowpass;
  return lowpass > THRESHOLD;
};
requestAudioAccess();

const hideElements = () => {
  const titleElement = document.getElementById("title");
  const candleElement = document.getElementById("candle");
  const canvasElement = document.getElementById("canvas");
  if (titleElement && candleElement && canvasElement) {
    titleElement.style.opacity = "0";
    candleElement.style.opacity = "0";
    canvasElement.style.opacity = "0";
    setTimeout(() => {
      titleElement.style.display = "none";
      candleElement.style.opacity = "none";
      canvasElement.style.opacity = "none";
      window.location.href = "timeline.html";
    }, 500);
  }
};

/////////////////////
//// CANDLE CODE ////
/////////////////////
const canvas = document.getElementById("canvas");
const ctx = canvas.getContext("2d");
const cw = (canvas.width = 800);
const ch = (canvas.height = 400);

const particles = [];
const MAX_PART_COUNT = 120;

const REIGNITE_RATE = 2; // rate at which flame will recover
const MAX_PART_DOWNTIME = 15; // max limit at which smothered flame will recover

const rand = (min, max) => min + Math.random() * (max - min);

// Fire Particle
class FlameParticle {
  constructor(x = cw / 2, y = ch / 2) {
    _defineProperty(
      this,
      "update",

      () => {
        if (this.curLife <= 90) {
          this.radius -= Math.min(this.radius, 0.25);
          this.curAlpha -= 0.005;
        }

        if (microphone && isBlowing()) {
          this.x += rand(-meter.volume, meter.volume) * 50;
        }

        this.curLife -= this.speed.y;
        this.y -= this.speed.y;
        this.draw();
      }
    );
    _defineProperty(
      this,
      "draw",

      () => {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, Math.PI * 2, false);
        ctx.fillStyle = `rgba(254, 252, 207, ${this.curAlpha})`;
        ctx.fill();
        ctx.closePath();
      }
    );
    this.radius = 15;
    this.speed = { x: rand(-0.5, 0.5), y: 2.5 };
    this.life = rand(50, 100);
    this.alpha = 0.5;
    this.x = x;
    this.y = y;
    this.curAlpha = this.alpha;
    this.curLife = this.life;
  }
}

// Flame Base
class FlameBase {
  constructor() {
    _defineProperty(
      this,
      "update",
      (this.draw = () => {
        ctx.beginPath();
        ctx.arc(cw / 2, ch / 2, 14, Math.PI * 2, false);
        ctx.fillStyle = "rgba(185, 125, 45, 0.4)";
        ctx.fill();
        ctx.closePath();
      })
    );
  }
}

////////////////////
let base = new FlameBase();
let particleCount = MAX_PART_COUNT;

const updateParticles = () => {
  for (let i = 0; i < particleCount; i++) {
    if (particles[i].curLife < 0) particles[i] = new FlameParticle();
    particles[i].update();
  }
};

const animate = () => {
  console.log("animating");
  requestAnimationFrame(animate);
  ctx.clearRect(0, 0, cw, ch);

  // Smother flame if user is blowing
  if (microphone && isBlowing())
    if (particleCount > -MAX_PART_DOWNTIME) particleCount -= 1;

  if (particleCount < 5) hideElements();

  // draw flame
  updateParticles();

  // draw base
  base.update();
};

// Initial particle generation
for (let i = 0; i < MAX_PART_COUNT; i++) particles.push(new FlameParticle());

// Interval to recover flames if smothered
setInterval(() => {
  if (particleCount < MAX_PART_COUNT) particleCount += REIGNITE_RATE;
}, 200);

animate();
